<app-header [navbarBrandRouterLink]="['/meter-management/home']" [fixed]="true"
  [sidebarToggler]="false"
  [mobileSidebarToggler]="true"
  [navbarBrandFull]="{src: '../../assets/img/brand/logo.png', width: 80, height: 40, alt: 'HD Logo'}"
  [navbarBrandMinimized]="{src: '../../assets/img/brand/logo.png', width: 80, height: 40, alt: 'HD Logo'}"
  [asideMenuToggler]="false" [mobileAsideMenuToggler]="false">
    <ul class="nav navbar-nav d-md-down-none">
      <li class="nav-item"><span class="home-title">{{homeTitle}}</span></li>
    </ul>
  <ul class="nav navbar-nav ml-auto">
<!--    <li class="nav-item dropdown mr-4" *ngIf="isAdmin">-->
<!--      <button class="dropdown-toggle btn btn-sm btn-outline-primary" id="navbarDropdown" role="button" data-toggle="dropdown" aria-expanded="false">-->
<!--        Quản lý-->
<!--      </button>-->
<!--      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">-->
<!--        <a *ngIf="isAdmin" class="dropdown-item" [routerLink]="['/meter-cooperative/cooperative']"><i class="fa fa-building" aria-hidden="true"></i> Quản lý HTX</a>-->
<!--      </div>-->
<!--    </li>-->
    <li class="nav-item dropdown" dropdown placement="bottom right">
      <a class="nav-link" role="button" aria-haspopup="true" aria-expanded="false"
        dropdownToggle (click)="false">
        <img src="../../assets/img/avatars/ava-default.svg" class="img-avatar" alt="admin@bootstrapmaster.com" />
      </a>
      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <button  class="dropdown-item" (click)="onLogout();"><i class="fa fa-lock"></i> Đăng xuất</button >
      </div>
    </li>
  </ul>
</app-header>
<div class="app-body">
  <app-sidebar [fixed]="true" [display]="'lg'">
    <app-sidebar-nav [navItems]="navItems" [perfectScrollbar] [disabled]="sidebarMinimized">
    </app-sidebar-nav>
    <app-sidebar-minimizer></app-sidebar-minimizer>
  </app-sidebar>
  <!-- Main content -->
  <main class="main page-action-fixed">
    <router-outlet></router-outlet>
  </main>
</div>
<dcu-notification></dcu-notification>
